import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getSettingsRequest,
  getSettingsSuccess,
  getSettingsFailure,
  saveSettingsRequest,
  saveSettingsSuccess,
  saveSettingsFailure,
  saveBirthdayGiftRequest,
  saveBirthdayGiftSuccess,
  saveBirthdayGiftFailure,
  saveRegistrationGiftRequest,
  saveRegistrationGiftSuccess,
  saveRegistrationGiftFailure,
  bulkGiftRequest,
  bulkGiftSuccess,
  bulkGiftFailure,
  addMinQtyRequest,
  addMinQtySuccess,
  addMinQtyFailure,
  addHsnCodeRequest,
  addHsnCodeSuccess,
  addHsnCodeFailure,
  metalRateStatesRequest,
  metalRateStatesSuccess,
  metalRateStatesFailure,
  saveOfferRequest,
  saveOfferSuccess,
  saveOfferFailure,
  expireOfferRequest,
  expireOfferSuccess,
  expireOfferFailure,
  createOrUpdateOfferRequest,
  createOrUpdateOfferSuccess,
  createOrUpdateOfferFailure,
  updateBenefitStatusRequest,
  updateBenefitStatusSuccess,
  updateBenefitStatusFailure,
  getUiArrangementRequest,
  getUiArrangementSuccess,
  getUiArrangementFailure,
  saveUiArrangementRequest,
  saveUiArrangementSuccess,
  saveUiArrangementFailure,
  savePaymentGatewayCountriesRequest,
  savePaymentGatewayCountriesSuccess,
  savePaymentGatewayCountriesFailure,
} from "./settingsSlice";
import { fetchBenefitsRequest } from "../Order/RedeemOrdersSlice";
// Worker saga
function* handleCreateOrUpdateOffer(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/referral/createOrUpdateOffer`,
      action.payload,
    );
    yield put(createOrUpdateOfferSuccess(response.data));
    if (response.data.success) {
      toast.success(response.data.message || "Offer created successfully");
      yield put(fetchBenefitsRequest({ start: 0, limit: 10 }));
    } else {
      toast.error(response.data.message || "Offer already exists");
    }
  } catch (error) {
    const errMsg = error.response?.data?.message || "Something went wrong";
    yield put(createOrUpdateOfferFailure(errMsg));
    toast.error(errMsg);
  }
}
function* getSettingsWorker() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/getSettings`,
    );
    yield put(getSettingsSuccess(response.data));
  } catch (error) {
    yield put(getSettingsFailure(error.message));
    toast.error("Failed to load settings");
  }
}

function* saveSettingsWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveSetting`,
      action.payload,
    );
    yield put(saveSettingsSuccess(response.data));
    yield put(getSettingsRequest());
  } catch (error) {
    yield put(saveSettingsFailure(error.message));
    toast.error("Failed to save settings");
  }
}

function* saveBirthdayGiftWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveBirthdayGiftDetails`,
      action.payload,
    );
    yield put(saveBirthdayGiftSuccess(response.data));
    yield put(getSettingsRequest());
    toast.success("Birthday gift saved successfully");
  } catch (error) {
    yield put(saveBirthdayGiftFailure(error.message));
    toast.error("Failed to save birthday gift");
  }
}

function* saveRegistrationGiftWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/saveRegistrationGiftDetails`,
      action.payload,
    );
    yield put(saveRegistrationGiftSuccess(response.data));
    yield put(getSettingsRequest());
    toast.success("Registration gift saved successfully");
  } catch (error) {
    yield put(saveRegistrationGiftFailure(error.message));
    toast.error("Failed to save registration gift");
  }
}

function* bulkGiftWorker(action) {
  try {
    console.log("payload", action.payload);
    let metalFormormData = new FormData();
    metalFormormData.append("sendtype", action.payload.sendtype);
    metalFormormData.append("phonelist", action.payload.phonelist);
    metalFormormData.append("weight", action.payload.weight);
    metalFormormData.append("metalName", action.payload.metalName);
    metalFormormData.append("purity", action.payload.purity);
    metalFormormData.append("occasion", action.payload.occasion);
    metalFormormData.append("giftvalidity", action.payload.giftvalidity);
    metalFormormData.append("customer", action.payload.bulkMetalGiftFile);
    const response = yield axios.post(
      //  `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/bulkpoints`
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/gift/bulkGift`,

      metalFormormData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    if (response.data?.errormsg) {
      toast.error(response.data.errormsg);
      yield put(bulkGiftFailure(response.data.errormsg));
      return;
    }
    yield put(bulkGiftSuccess(response.data));
    yield put(getSettingsRequest());
    toast.success(response.data?.data || "Bulk gift sent successfully");
  } catch (error) {
    console.log("error", error);
    yield put(bulkGiftFailure(error.message));
    toast.error("Failed to send bulk gift");
  }
}

function* addMinQtyWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/BullionMinQty/addMinQty`,
      action.payload,
    );
    yield put(addMinQtySuccess(response.data));
    yield put(getSettingsRequest());
    toast.success("Minimum quantity added successfully");
  } catch (error) {
    yield put(addMinQtyFailure(error.message));
  }
}

function* addHsnCodeWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/addHsnCode`,
      action.payload,
    );
    yield put(addHsnCodeSuccess(response.data));
    yield put(getSettingsRequest());
    toast.success("HSN Code added successfully");
  } catch (error) {
    yield put(addHsnCodeFailure(error.message));
  }
}

function* metalRateStatesWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/metalRateStates`,
      action.payload,
    );
    yield put(metalRateStatesSuccess(response.data));
    toast.success("State added successfully ");
    yield put(getSettingsRequest());
  } catch (error) {
    yield put(metalRateStatesFailure(error.message));
    yield put(getSettingsRequest());
  }
}

function* saveOfferWorker(action) {
  try {
    console.log("Received payload in saga:", action.payload);
    console.log("Start Date (raw):", action.payload.startDate);
    console.log("End Date (raw):", action.payload.endDate);

    const formData = new FormData();
    formData.append("startDate", action.payload.startDate);
    formData.append("endDate", action.payload.endDate);
    formData.append("file", action.payload.file);

    console.log("FormData being sent:");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/offer/saveOfferDetails`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    console.log("saveOfferSuccess", response.data);
    yield put(saveOfferSuccess(response.data));
    yield put(getSettingsRequest());
    toast.success("Offer details saved successfully");
  } catch (error) {
    yield put(saveOfferFailure(error.message));
    toast.error("Failed to save offer details");
  }
}

function* expireOfferWorker(action) {
  try {
    const response = yield call(
      axios.patch,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/offer/expireOffer`,
      action.payload,
    );
    console.log("expiresd", response.data);
    yield put(expireOfferSuccess(response.data));
    yield put(getSettingsRequest());
    toast.success("Offer expired successfully");
  } catch (error) {
    yield put(expireOfferFailure(error.message));
    toast.error("Failed to expire offer");
  }
}
function* updateBenefitStatusWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/referral/updateBenefitStatus`,
      action.payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );

    yield put(updateBenefitStatusSuccess(response.data));

    if (response.data.success) {
      toast.success(
        response.data.message || "Benefit status updated successfully",
      );
      yield put(fetchBenefitsRequest({ start: 0, limit: 10 }));
    } else {
      toast.error(response.data.message || "Failed to update benefit status");
    }
  } catch (error) {
    const errMsg = error.response?.data?.message || "Something went wrong";
    yield put(updateBenefitStatusFailure(errMsg));
    toast.error(errMsg);
  }
}

function* getUiArrangementWorker() {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/ui-arrangement/list`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    yield put(getUiArrangementSuccess(response.data.data));
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch UI arrangement";
    yield put(getUiArrangementFailure(errMsg));
    toast.error(errMsg);
  }
}

function* savePaymentGatewayCountriesWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/setting/savePaymentGatewayCountries`,
      action.payload,
    );
    yield put(savePaymentGatewayCountriesSuccess(response.data));
    yield put(getSettingsRequest());
    toast.success(
      response.data?.message ||
        "Payment gateway countries saved successfully",
    );
  } catch (error) {
    const errMsg =
      error.response?.data?.message ||
      error.message ||
      "Failed to save payment gateway countries";
    yield put(savePaymentGatewayCountriesFailure(errMsg));
    toast.error(errMsg);
  }
}

function* saveUiArrangementWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/ui-arrangement/saveUiArrangement`, // your API
      action.payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      },
    );

    if (response.data.success) {
      yield put(saveUiArrangementSuccess(response.data.data));
      toast.success(
        response.data.message || "UI Arrangement saved successfully",
      );
    } else {
      yield put(saveUiArrangementFailure(response.data.message));
      toast.error(response.data.message || "Failed to save UI Arrangement");
    }
  } catch (error) {
    const errMsg =
      error.response?.data?.message || error.message || "Something went wrong";
    yield put(saveUiArrangementFailure(errMsg));
    toast.error(errMsg);
  }
}

export function* watchSettingsSaga() {
  yield takeLatest(createOrUpdateOfferRequest.type, handleCreateOrUpdateOffer);

  yield takeLatest(getSettingsRequest.type, getSettingsWorker);
  yield takeLatest(saveSettingsRequest.type, saveSettingsWorker);
  yield takeLatest(saveBirthdayGiftRequest.type, saveBirthdayGiftWorker);
  yield takeLatest(
    saveRegistrationGiftRequest.type,
    saveRegistrationGiftWorker,
  );
  yield takeLatest(bulkGiftRequest.type, bulkGiftWorker);
  yield takeLatest(addMinQtyRequest.type, addMinQtyWorker);
  yield takeLatest(addHsnCodeRequest.type, addHsnCodeWorker);
  yield takeLatest(metalRateStatesRequest.type, metalRateStatesWorker);
  yield takeLatest(saveOfferRequest.type, saveOfferWorker);
  yield takeLatest(expireOfferRequest.type, expireOfferWorker);
  yield takeLatest(updateBenefitStatusRequest.type, updateBenefitStatusWorker);
  yield takeLatest(getUiArrangementRequest.type, getUiArrangementWorker);
  yield takeLatest(saveUiArrangementRequest.type, saveUiArrangementWorker);
  yield takeLatest(
    savePaymentGatewayCountriesRequest.type,
    savePaymentGatewayCountriesWorker,
  );
}
